import { API_ENDPOINTS } from '@/api/endpoints.constant';
import { systemConfig } from '@/config/systemConfig';
import { clivApiRequest } from '@/utils/apiClient';

const HTTP_UNAUTHORIZED = 401;
const HTTP_FORBIDDEN = 403;
const HTTP_NOT_FOUND = 404;
const HTTP_CONFLICT = 409;

const ABANDON_FAILURE_MESSAGE_KEY_BY_STATUS: Readonly<Record<number, string>> = {
  [HTTP_UNAUTHORIZED]: 'Abandon_Inspection_Session_Expired',
  [HTTP_FORBIDDEN]: 'Abandon_Inspection_Not_Assigned',
  [HTTP_NOT_FOUND]: 'Abandon_Inspection_Not_Found',
  [HTTP_CONFLICT]: 'Abandon_Inspection_Status_Changed',
};

const ABANDON_FAILURE_FALLBACK_MESSAGE_KEY = 'Abandon_Inspection_Request_Failed';

export type InspectionAbandonResult =
  | { readonly ok: true }
  | { readonly ok: false; readonly messageKey: string };

/**
 * Maps a failed abandon response to a translation key that tells the inspector what to do next.
 */
export const resolveAbandonFailureMessageKey = (status: number): string =>
  ABANDON_FAILURE_MESSAGE_KEY_BY_STATUS[status] ?? ABANDON_FAILURE_FALLBACK_MESSAGE_KEY;

/**
 * Asks the server to return the inspection to Planned with no date and no assigned inspector.
 */
export async function requestInspectionAbandon(
  inspectionId: string
): Promise<InspectionAbandonResult> {
  const response = await clivApiRequest<{ message: string }>({
    method: 'POST',
    url: `${systemConfig.apiUrl}/${API_ENDPOINTS.INSPECTION.INSPECTIONS}/${inspectionId}/abandon`,
  });
  if (response.ok) {
    return { ok: true };
  }
  return { ok: false, messageKey: resolveAbandonFailureMessageKey(response.status) };
}
